module.exports = __webpack_public_path__ + "img/upload.fe6227c8.svg";